import { render } from "./Fort.vue?vue&type=template&id=5591aabf"
import script from "./Fort.vue?vue&type=script&lang=js"
export * from "./Fort.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/buildings/Fort.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5591aabf"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5591aabf', __exports__)) {
    api.reload('5591aabf', __exports__)
  }
  
  module.hot.accept("./Fort.vue?vue&type=template&id=5591aabf", () => {
    api.rerender('5591aabf', render)
  })

}


export default __exports__